<nz-form-item>
  <span [class]="labelClass">{{ label }}</span>
  <nz-form-control [nzValidateStatus]="convertErrorsNz[inputFormControl.status]">
    <nz-radio-group [nzDisabled]="readonly" [formControl]="asFormControl(inputFormControl)">
      @for (button of buttons; track trackByButton($index, button)) {
      <span nz-radio-button [nzValue]="button[_optionsRadioGroup.value]">{{ button[_optionsRadioGroup.label] }}</span>
      }
    </nz-radio-group>
  </nz-form-control>
</nz-form-item>
